import QRCode from "qrcode";
import { useEffect, useState } from "react";
import s from "./billing.module.css";

/**
 * Draws `value` as an SVG QR code, generated locally in the browser (no network, no QR service).
 * The library's default colours are used on purpose: black modules on a white ground with a 4-module quiet zone,
 * so the code scans the same in any theme.
 */
export function QrCode({ value, label }: { value: string; label: string }) {
  const [svg, setSvg] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    setSvg(null);
    setFailed(false);
    QRCode.toString(value, { type: "svg", margin: 4, errorCorrectionLevel: "M" }).then(
      (out) => { if (live) setSvg(out); },
      () => { if (live) setFailed(true); },
    );
    return () => { live = false; };
  }, [value]);

  if (failed) return <p role="alert" className={s.err}>The QR code could not be drawn. Use the link below instead.</p>;
  if (!svg) return <div className={s.qrImg} aria-hidden="true" data-testid="qr-pending" />;
  // The markup comes from our own encoder run over the value; it contains only a viewBox and two paths.
  return <div className={s.qrImg} role="img" aria-label={label} data-testid="qr-code" dangerouslySetInnerHTML={{ __html: svg }} />;
}
